import React from 'react';
import { Avatar, Button } from 'antd';
import { UserOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getImg } from '../../../Api/getImg';

const getPdfUrl = (docId) => {
    if (!docId) return null;
    const baseURL = process.env.REACT_APP_BASE_URL;
    return `${baseURL}/api/Storage/GetPDFById?Id=${docId}`;
};

const ChatMessage = ({ 
    comment, 
    isCurrentUser, 
    getStaffInfo 
}) => {
    const staff = getStaffInfo(comment.userId);
    
    return (
        <div className={`mb-4 flex ${isCurrentUser ? 'justify-end' : 'justify-start'}`}>
            <div className={`flex items-start gap-3 max-w-2xl ${isCurrentUser ? 'flex-row-reverse' : ''}`}>
                <Avatar 
                    size={32} 
                    icon={<UserOutlined />} 
                    className={`flex-shrink-0 ${
                        isCurrentUser ? 'bg-[#298d9f]' : 'bg-gray-400'
                    }`}
                />
                <div className={`flex-1 ${isCurrentUser ? 'items-end' : 'items-start'} flex flex-col`}>
                    <div className={`flex items-center gap-2 mb-1 ${isCurrentUser ? 'flex-row-reverse' : ''}`}>
                        <span className="font-medium text-xs text-gray-700">
                            {staff?.name || 'Unknown'}
                        </span>
                        <span className="text-xs text-gray-400">
                            {dayjs(`${comment.createdAt}Z`).format('h:mm A')}
                        </span>
                    </div>
                    <div 
                        className={`rounded-lg p-3 shadow-sm ${
                            isCurrentUser 
                                ? 'bg-[#298d9f] text-white' 
                                : 'bg-white border border-gray-200'
                        }`}
                    >
                        {/* Text Message */}
                        {comment.comment && (
                            <p className={`text-sm ${isCurrentUser ? 'text-white' : 'text-gray-800'} mb-2`}>
                                {comment.comment}
                            </p>
                        )}
                        
                        {/* Image Attachment */}
                        {comment.photoId && (
                            <div className="mt-2">
                                <img
                                    src={getImg(comment.photoId)}
                                    alt="Attachment"
                                    className="rounded max-w-full max-h-40 cursor-pointer hover:opacity-90 transition"
                                    onClick={() => window.open(getImg(comment.photoId), '_blank')}
                                />
                            </div>
                        )}
                        
                        {/* PDF Attachment */}
                        {comment.docId && (
                            <div className={`mt-2 flex items-center gap-2 p-2 rounded ${
                                isCurrentUser ? 'bg-white/10' : 'bg-gray-50'
                            }`}>
                                <FileOutlined className={isCurrentUser ? 'text-white' : 'text-blue-600'} />
                                <span className={`text-xs flex-1 ${isCurrentUser ? 'text-white' : 'text-gray-700'}`}>
                                    Document.pdf
                                </span>
                                <Button
                                    type="link"
                                    size="small"
                                    icon={<DownloadOutlined />}
                                    href={getPdfUrl(comment.docId)}
                                    target="_blank"
                                    className={isCurrentUser ? 'text-white' : ''}
                                >
                                    Download
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatMessage;